import { ModelProxy } from '@lib/model-proxy';
import { intentModel } from './intent';
import { compositeModel } from './composite-attr';
import { serviceModel } from './service';
import { agentModal } from './agent';
import { globalModel } from './global';
import { persistStore, persistReducer } from 'redux-persist';
import session from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import { combineReducers, createStore } from 'redux';
import { storeMiddleware } from '@middleware/index';

export const modals = [agentModal, intentModel, compositeModel, serviceModel, globalModel];

const reducerMap: any = {};

modals.forEach((modal: ModelProxy) => {
  reducerMap[modal.namespace] = modal.reducer;
});

const persistConfig = {
  storage: session,
  key: 'root',
  stateReconciler: autoMergeLevel2 // 查看 'Merge Process' 部分的具体情况
};

export const reducers: any = combineReducers(reducerMap);

const myPersistReducer = persistReducer(persistConfig, reducers);

export const store: any = createStore(myPersistReducer, storeMiddleware);
export const persistor = persistStore(store);
